import { render } from "./SubmenuCard.vue?vue&type=template&id=1aaa090b&scoped=true"
import script from "./SubmenuCard.vue?vue&type=script&lang=js"
export * from "./SubmenuCard.vue?vue&type=script&lang=js"

import "./SubmenuCard.vue?vue&type=style&index=0&id=1aaa090b&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aaa090b"]])

export default __exports__